import { useTantalimMutation } from '../mutation'
import { type LocationMatchInput, type LocationMatchSuccess, messageFromError, toResponseError } from '@terros/common'

type UseMatchLocationReturnType = {
  match: (input: LocationMatchInput) => Promise<LocationMatchSuccess>
  isLoading: boolean
  error?: string
}

export function useMatchLocation(): UseMatchLocationReturnType {
  const mutation = useTantalimMutation<LocationMatchInput, LocationMatchSuccess>({ url: '/location/match' })

  async function match(input: LocationMatchInput): Promise<LocationMatchSuccess> {
    try {
      const output = await mutation.mutateAsync(input)

      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return { match, isLoading: mutation.isPending, error: messageFromError(mutation.error) }
}
